import React from 'react'
import { TextColors, Typography } from '@sureco/design-system'
import { Switch, SwitchProps } from '@surecompanies/core_components'
import { Control, Controller, UseControllerProps } from 'react-hook-form'

type RHFToggleProps = Omit<SwitchProps, 'name'> & {
  name: string
  control: Control<any, object>
  rules?: UseControllerProps['rules']
  label?: string
}

export default function RHFToggle({
  name,
  control,
  rules,
  label,
  ...rest
}: RHFToggleProps) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => {
        const isDisabled = Boolean(rest.disabled)
        const rowClass = [
          'toggleRow',
          isDisabled ? 'toggleWrapperDisabled' : '',
        ]
          .filter(Boolean)
          .join(' ')

        // Strip `disabled` from Switch props — the wrapper's pointer-events: none
        // handles interaction prevention, so the Switch renders at full visual
        // fidelity instead of fading out in read-only views.
        const { disabled: _disabled, ...switchProps } = rest

        return (
          <div className={rowClass}>
            {label && <Typography className="toggleLabel">{label}</Typography>}
            <div>
              <Switch
                value={field.value}
                onChange={(event) => {
                  field.onChange(event)
                }}
                ref={field.ref}
                {...switchProps}
              />
            </div>
            {fieldState.error && (
              <Typography color={TextColors.error}>
                {fieldState.error.message}
              </Typography>
            )}
          </div>
        )
      }}
    />
  )
}
